import styled from '@emotion/styled'

import { Image } from '@/components/Image'
import { CONFIG } from '@/styles/emotion.config'

const Container = styled.div`
  .mediaWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2.5rem 1rem;
  }

  .mediaText__firstPart,
  .mediaImage,
  .mediaWrapper .content__secondPart {
    width: 100%;
  }

  .mediaText__firstPart {
    padding: 0;
  }

  .mediaText__firstPart > .title + .content__firstPart {
    margin: 0.5rem 0 0;
  }

  .mediaImage {
    max-width: 22rem;
    object-fit: contain;
  }

  .mediaWrapper > .mediaImage {
    width: 73.335vw;
  }

  .mediaWrapper .content__secondPart {
    margin-top: 1rem;
  }

  .mediaText__firstPart + .mediaImage {
    margin: 1rem auto 0;
  }

  ${CONFIG.media.lg} {
    .mediaWrapper {
      display: grid;
      grid-template-rows: 1rem 2fr 1rem;
      grid-template-columns: 328px 1fr;
      grid-column-gap: 6.313rem;
      align-items: center;
      padding: 5rem 0;
    }

    .mediaImage {
      grid-column: 1/1;
      grid-row: 1/5;
    }

    .mediaWrapper > .mediaImage {
      width: 100%;
    }

    .mediaImage {
      margin: 0;
      max-width: 100%;
    }

    .mediaText__firstPart,
    .content__secondPart {
      max-width: 26.875rem;
    }

    .mediaWrapper .content__secondPart {
      margin-top: unset;
    }

    .mediaText__firstPart,
    .mediaWrapper .content__secondPart {
      width: auto;
      grid-column: 2/2;
      grid-row: 2/2;
    }

    .mediaWrapper .content__secondPart {
      align-self: self-start;
      grid-row: 3/3;
    }

    .mediaWrapper {
      align-self: flex-start;
    }

    .mediaWrapper {
      grid-template-rows: 1rem auto auto 1rem;
    }

    .mediaWrapper .mediaText__firstPart {
      align-self: flex-end;
    }

    .mediaText__firstPart + .mediaImage,
    .mediaWrapper .mediaText__firstPart .title {
      margin: 0;
    }

    .mediaWrapper .mediaText__firstPart .title + .content__firstPart {
      margin: 1rem 0 0;
    }
  }
`

const MediaWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0;
  max-width: ${CONFIG.maxWidths.md};

  ${CONFIG.media.mobileLg} {
    margin: unset;
  }
`

const StyledImage = styled(Image)`
  ${CONFIG.media.mobileLg} {
    top: 1rem;
  }
`

export { Container, MediaWrapper, StyledImage }
